document.addEventListener('DOMContentLoaded', function() {
    const flowSteps = document.querySelectorAll('.flow-step-item');
    const flowDetails = document.querySelectorAll('.flow-detail-content');
    let currentIndex = 0;
  
    // 初期表示
    flowDetails.forEach(detail => detail.classList.remove('is-active'));
    flowDetails[currentIndex].classList.add('is-active');
    flowSteps.forEach(step => step.classList.remove('is-active'));
    flowSteps[currentIndex].classList.add('is-active');
  
    // 一定時間で次のコンテンツを表示する関数
    function showNextContent() {
      flowDetails[currentIndex].classList.remove('is-active');
      flowSteps[currentIndex].classList.remove('is-active');
      currentIndex = (currentIndex + 1) % flowDetails.length;
      flowDetails[currentIndex].classList.add('is-active');
      flowSteps[currentIndex].classList.add('is-active');
    }
  
    // 一定時間間隔でコンテンツを切り替える (例: 3秒)
    const intervalTime = 3000;
    let intervalId = setInterval(showNextContent, intervalTime);
  
    // ステップナンバーがクリックされた時の処理
    flowSteps.forEach(step => {
      step.addEventListener('click', function() {
        clearInterval(intervalId); // 自動切り替えを停止
  
        const stepNumber = parseInt(this.dataset.step);
        const targetIndex = stepNumber - 1;
  
        // 全ての詳細コンテンツとステップを非アクティブにする
        flowDetails.forEach(detail => detail.classList.remove('is-active'));
        flowSteps.forEach(item => item.classList.remove('is-active'));
  
        // クリックされたステップに対応するコンテンツとステップをアクティブにする
        if (flowDetails[targetIndex]) {
          flowDetails[targetIndex].classList.add('is-active');
          this.classList.add('is-active');
          currentIndex = targetIndex; // 現在のインデックスを更新
        }
  
        // 必要であれば、再度自動切り替えを開始
        // intervalId = setInterval(showNextContent, intervalTime);
      });
    });
  });